<template>
    <div>
        <RatingComp/>
    </div>
</template>

<script>
import RatingComp from '@/components/RatingComp.vue';


export default {
  name: "OwnerHomeComp",
  components: {
      RatingComp
  },
//   data() {
//     return {

//     };
//   }
}

</script>